/** * 模块名称: LearningMachine.vue - 学习机 * 模块说明: * 创建时间: 2022-02-15
11:36 * 模块负责人: lkc * 修改记录: */
<template>
  <div>
    <!-- 头部 -->
    <div class="headBanner">
      <div class="headClass">
        <div class="tit">
          <h1>A.I.一对一个性化精确辅导</h1>
          <h1>因材施教，方能独占鳌头</h1>
          <h1>讲、学、练、一站式掌握知识</h1>
        </div>
        <!-- <img src="@/assets/yj_3.png" alt="" /> -->
      </div>
    </div>
    <div class="contBox">
      <!--选择我们的六大理由  -->
      <h1>选择我们的六大理由</h1>
      <ul class="subsystemCont">
        <li
          v-for="item in listArr"
          :key="item.id"
          @mouseenter="mshow(index)"
          @mouseleave="mhidden(index)"
        >
          <!-- <img :src="item.url" alt=""> -->
          <span class="subsystemSpan">{{ item.tit }}</span>
          <!-- 蒙层 -->
          <div class="mask" v-show="aaaa">
            <span>{{ item.tit }}</span>
            <span>{{ item.cont }} </span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      listArr: [
        {
          id: 1,
          url: require('@/assets/yc4.png'),
          tit: '学习资源丰富',
          cont: '幼儿早教、小初高同步、老年养生、戏剧美食'
        },
        {
          id: 2,
          url: require('@/assets/yc4.png'),
          tit: '专注学习',
          cont: '多重拦截，保障学习机内容纯净'
        },
        {
          id: 3,
          url: require('@/assets/yc4.png'),
          tit: '智能护眼',
          cont: '精选过滤蓝光CPU芯片、距感和光感护眼芯片，坐姿识别/抖动提醒等多重护眼功能'
        },
        {
          id: 4,
          url: require('@/assets/yc4.png'),
          tit: '家长管控',
          cont: '禁止下载垃圾软件，一键锁屏，远程截屏、定位，一键抓拍，全方位智能监控'
        },
        {
          id: 5,
          url: require('@/assets/yc4.png'),
          tit: 'AI互动学习',
          cont: '实现手指点读、整篇文章真人阅读，复习、跟读、听读等多种学习功能'
        },
        {
          id: 6,
          url: require('@/assets/yc4.png'),
          tit: '优质硬件',
          cont: '高清摄像头、至强八核、高清大屏、大容量电池'
        }
      ],
      aaaa: false
    }
  },
  methods: {
    mshow() {
      this.aaaa = true
    },
    mhidden() {
      this.aaaa = false
    }
  }
}
</script>

<style lang="less" scoped>
.headBanner {
  background: url('../../assets/xxjBanner.png');
  background-size: 100% 100%;
  .headClass {
    width: 1200px;
    height: 360px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .tit {
      width: 60%;
      color: #fff;
      // color: #000;
      text-align: left;
    }
    img {
      width: 30%;
    }
  }
}
.contBox {
  padding: 30px;
  background: #f2f2f2;
  width: 1200px;
  margin: 0 auto;
  .subsystemCont {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    li {
      width: 250px;
      height: 100px;
      background-color: #fff;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      box-shadow: 5px 5px 5px #36b2e7;
      border: 1px solid #2e5e9e;
      position: relative;
      margin-right: 50px;
      margin-bottom: 30px;
      .subsystemSpan {
        font-size: 22px;
        text-align: center;
      }
      .mask {
        width: 250px;
        height: 100px;
        background-color: #02a7f0;
        color: #fff;
        opacity: 0;
        position: absolute;
        top: 0;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        border-radius: 10px;
        padding: 5px;
        span:first-child {
          font-size: 18px;
          margin-bottom: 5px;
        }
        span:last-child {
          text-align: left;
        }
      }
    }
    li:hover .mask {
      opacity: 1;
      //  transition: all 0.5s ease 0s;
    }
  }
}
</style>
